module.exports = __webpack_public_path__ + "img/zhxd.7001b27b.png";